import Cookies from 'js-cookie'

const TokenKey = 'SDrxEA%_tWW6ezd3'
const AutoLoginKey = 'auto_login_range'

// 自动登录天数
export const AUTO_LOGIN_DAYS = 7

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token, expires = 0) {
    if (expires) return Cookies.set(TokenKey, token, { expires })
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}

/**
 * 自动登录偏好，仅前端使用，无需随请求发送，故存 localStorage
 * @returns {number} 勾选时为天数，未勾选为 0
 */
export function getAutoLoginRange() {
    return parseInt(localStorage.getItem(AutoLoginKey)) || 0
}

export function setAutoLoginRange(days) {
    if (days > 0) return localStorage.setItem(AutoLoginKey, days)
    return localStorage.removeItem(AutoLoginKey)
}
